/*
 * @Author: kangkang 1278279046@qq.com
 * @Date: 2022-05-20 11:49:44
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2023-02-06 16:38:41
 * @FilePath: \experience-pc\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const routerPC = [
    
    {
        path: '/',
        name: 'main',
        component: () =>
            import ('../views/main/main'),
    },
    {
        path: '/plaza',
        name: 'plaza',
        component: () =>
            import ('../views/plaza/index'),
    },
    {
        path: '/note/detail',
        name: 'note/detail',
        component: () =>
            import ('../views/plaza/detail'),
    },
    {
        path: '/experiencer/service',
        name: 'experiencer/service',
        component: () =>
            import ('../views/main/details'),
    },
    {
        path: '/register/experiencer',
        name: 'experiencer',
        component: () =>
            import ('../views/experiencer/register_experiencer'),
    },
    {
        path: '/mine',
        name: 'userCenter',
        component: () =>
            import ('../components/UserCenter'),
        meta: {
            requireAuth: true,
        },
        children: [{
                path: '/mine/mine',
                name: 'mine/mine',
                meta: { requireAuth: true },
                component: () =>
                    import ('../views/mine/mine')
            },
            {
                path: '/mine/order',
                name: 'mine/order',
                meta: { requireAuth: true },
                component: () =>
                    import ('../views/mine/order')
            },
            {
                path: '/mine/services/order',
                name: 'mine/services/order',
                meta: { requireAuth: true },
                component: () =>
                    import ('../views/mine/service_order')
            },
            {
                path: '/mine/services',
                name: 'mine/services',
                meta: { requireAuth: true },
                component: () =>
                    import ('../views/mine/services')
            },
            {
                path: '/mine/wallet',
                name: 'mine/wallet',
                meta: { requireAuth: true },
                component: () =>
                    import ('../views/mine/wallet')
            },

        ]
    }
]

const routerMi = [
    {
        path: '/',
        name: "mi",
        component: () =>
            import ('../views/mi/index'),
        meta: {
            keepAlive: true
        }
    },

    {
        path: '/miplaza/detail',
        name: 'miplazadetail',
        component: () =>
            import ('../views/mi/plazadetail'),
    },
    {
        path: '/mirequire/detail',
        name: 'mirequireDetail',
        component: () =>
            import ('../views/mi/mirequire'),
    },
    {
        path: '/miuser/detail',
        name: 'mirequireDetail',
        component: () =>
            import ('../views/mi/userdetail'),
    },
    {
        path: '/mi/schools',
        name: 'schools',
        component: () =>
            import ('../views/mi/schools'),
    },

    {
        path: '/mi/colleges',
        name: 'colleges',
        component: () =>
            import ('../views/mi/colleges'),
    },
    {
        path: '/mi/countrys',
        name: 'countrys',
        component: () =>
            import ('../views/mi/countrys'),
    },
    {
        path: '/mi/majors',
        name: 'majoys',
        component: () =>
            import ('../views/mi/major'),
    }
]

var routers = []

if (navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )){
    routers = routerMi;
}else{
    routers = routerPC;
}


// _isMobile() {
//     // return false
//     let flag = navigator.userAgent.match(
//       /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
//     );
//     return flag;
//   },

// const router = new Router({
//     routes: [

//         {
//             path: '/',
//             name: 'main',
//             component: () =>
//                 import ('../views/main/main'),
//         },
//         {
//             path: '/plaza',
//             name: 'plaza',
//             component: () =>
//                 import ('../views/plaza/index'),
//         },
//         {
//             path: '/note/detail',
//             name: 'note/detail',
//             component: () =>
//                 import ('../views/plaza/detail'),
//         },
//         {
//             path: '/experiencer/service',
//             name: 'experiencer/service',
//             component: () =>
//                 import ('../views/main/details'),
//         },
//         {
//             path: '/register/experiencer',
//             name: 'experiencer',
//             component: () =>
//                 import ('../views/experiencer/register_experiencer'),
//         },
//         {
//             path: '/mine',
//             name: 'userCenter',
//             component: () =>
//                 import ('../components/UserCenter'),
//             meta: {
//                 requireAuth: true,
//             },
//             children: [{
//                     path: '/mine/mine',
//                     name: 'mine/mine',
//                     meta: { requireAuth: true },
//                     component: () =>
//                         import ('../views/mine/mine')
//                 },
//                 {
//                     path: '/mine/order',
//                     name: 'mine/order',
//                     meta: { requireAuth: true },
//                     component: () =>
//                         import ('../views/mine/order')
//                 },
//                 {
//                     path: '/mine/services/order',
//                     name: 'mine/services/order',
//                     meta: { requireAuth: true },
//                     component: () =>
//                         import ('../views/mine/service_order')
//                 },
//                 {
//                     path: '/mine/services',
//                     name: 'mine/services',
//                     meta: { requireAuth: true },
//                     component: () =>
//                         import ('../views/mine/services')
//                 },
//                 {
//                     path: '/mine/wallet',
//                     name: 'mine/wallet',
//                     meta: { requireAuth: true },
//                     component: () =>
//                         import ('../views/mine/wallet')
//                 },

//             ]
//         },
//         {
//             path: '/mi',
//             name: "mi",
//             component: () =>
//                 import ('@/views/mi/index'),
//             meta: {
//                 keepAlive: true
//             }
//         },

//         {
//             path: '/miplaza/detail',
//             name: 'miplazadetail',
//             component: () =>
//                 import ('@/views/mi/plazadetail'),
//         },
//         {
//             path: '/mirequire/detail',
//             name: 'mirequireDetail',
//             component: () =>
//                 import ('@/views/mi/mirequire'),
//         },
//         {
//             path: '/miuser/detail',
//             name: 'mirequireDetail',
//             component: () =>
//                 import ('@/views/mi/userdetail'),
//         },
//         {
//             path: '/mi/schools',
//             name: 'schools',
//             component: () =>
//                 import ('@/views/mi/schools'),
//         },

//         {
//             path: '/mi/colleges',
//             name: 'colleges',
//             component: () =>
//                 import ('@/views/mi/colleges'),
//         },
//         {
//             path: '/mi/countrys',
//             name: 'countrys',
//             component: () =>
//                 import ('@/views/mi/countrys'),
//         },
//         {
//             path: '/mi/majors',
//             name: 'majoys',
//             component: () =>
//                 import ('@/views/mi/major'),
//         }
//     ],
//     mode: 'history'
// })

const router = new Router({
    mode: "history",
    routes:routers
  })

export default router


// WEBPACK FOOTER //
// ./src/router/index.js